export default __webpack_public_path__ + "static/media/landing1.00e498d2.jpg";